import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import cn from 'classnames';
import PropTypes from 'prop-types';
import BrowserStore from '../../browser/stores/BrowserStore';
import { EnvStoreProps, ResearchStoreProp } from '../../stores/props';
import UDExitIsolation from '../UD/Fragments/UDExitIsolation';
import TopBarUrl from '../TopBarUrl/TopBarUrl';
import TopBarNewTab from '../TopBarNewTab/TopBarNewTab';
import TopBarLogo from '../TopBarLogo/TopBarLogo';
import TopBarMenuButton from '../TopBarMenuButton/TopBarMenuButton';
import TopBarResearchLocation from '../TopBarResearchLocation/TopBarResearchLocation';
import TopBarResearchUA from '../TopBarResearchUA/TopBarResearchUA';
import BannerNotification from '../Notification/BannerNotification';
import FileProcessingNotification from '../Notification/FileProcessingNotification';
import { isBrowserFuse5Enabled } from '../../fuseFeatureFlag';
import OldTopBarAlternative from './OldTopBarAlternative';
import './TopBarAlternative.new.css';
import './../TopBarCaret.css';


const altTopBarBlock = b.lock('Fuse5TopBarAlternative');

class NewTopBarAlternative extends Component {
    static propTypes = {
        browser: BrowserStore.PropType.isRequired,
        env: EnvStoreProps,
        isWizard: PropTypes.bool,
        onSubmit: PropTypes.func,
        research: ResearchStoreProp,
        onRefresh: PropTypes.func,
    };
    static defaultProps = {
        onRefresh: () => {
        },
        onSubmit: () => {
        },
    };

    barRef = React.createRef();


    refreshMinified = (leaveExpanded) => () => {
        if (!this.props.browser.isTopBarMinimizable()) {
            return;
        }
        if (!this.barRef.current) {
            return;
        }
        const active = this.barRef.current.contains(document.activeElement);
        const result = leaveExpanded || active;
        this.props.browser.topBarNeedsMinimization.setValue(result);
    }

    getResearchBtnProps = (active) => {
        const { browser, onRefresh } = this.props;
        const minified = browser.isTopBarMinificationAllowed();

        return {
            className: altTopBarBlock('Shortcut'),
            btnProps: {
                className: altTopBarBlock('ResearchButton', { minified }),
                iconRightClassName: b.lock('TopBarCaret')({ active, minified }),
            },
            onRefresh,
        };
    }

    getShortcutBtnProps = (subOptions) => {
        const { isWizard } = this.props;

        return {
            isWizard,
            className: altTopBarBlock('Shortcut', subOptions),
            btnProps: {
                className: altTopBarBlock('IconButton'),
            },
        };
    }

    simulateUnfocusedMousedOverTopBar = () => {
        document.activeElement.blur();
        this.refreshMinified(true)();
    }

    render() {
        const { browser, research, env, isWizard } = this.props;
        const isMinified = browser.isTopBarMinificationAllowed();
        const state = browser.getVisualState();

        return <div
            ref={this.barRef}
            className={cn('notranslate', altTopBarBlock({
                research: research.researchMode.isEnabled,
                minified: isMinified,
                noTransition: browser.isHomePage,
                isWizard,
                state,
                homepage: browser.isHomePage,
                mobile: env.screen.isMobile,
                isFloatingIconEnabled: browser.isFloatingIconEnabled(),
            }))}
            onClick={() => {
                browser.topBarMenu.close();
            }}
            onFocus={this.refreshMinified(true, 'onFocus')}
            onBlur={this.refreshMinified(false, 'onBlur')}
            onMouseEnter={this.refreshMinified(true, 'onMouseEnter')}
            onMouseLeave={this.refreshMinified(false, 'onMouseLeave')}
        >
            <div className={altTopBarBlock('innerdiv', {
                mobile: env.screen.isMobile,
                minified: isMinified,
                isFloatingIconEnabled: browser.isFloatingIconEnabled(),
            })}
            >
                <TopBarLogo isWizard={isWizard} />

                <TopBarUrl
                    className={altTopBarBlock('Url', { minified: isMinified, mobile: env.screen.isMobile })}
                    onSubmit={this.props.onSubmit}
                    isWizard={isWizard}
                    isMinified={isMinified}
                />

                {!env.screen.isMobile
                && !env.screen.isTablet
                && research.researchMode.isEnabled
                && !isWizard
                    ? <Fragment>
                        <TopBarResearchLocation {...this.getResearchBtnProps(research.locationMenu.isOpen)} />
                        <TopBarResearchUA {...this.getResearchBtnProps(research.userAgentMenu.isOpen)} />
                    </Fragment>
                    : null
                }

                {!env.isUrlIsolation && !env.isSaasIsolation && !env.screen.isMobile ? <Fragment>
                    <TopBarNewTab {...this.getShortcutBtnProps({ shrunken: isMinified })} />
                </Fragment> : null}

                {env.isUrlIsolation && browser.canExitIsolation()
                    ? <UDExitIsolation
                        className={altTopBarBlock('Shortcut', { minified: isMinified, type: 'exit' })}
                    />
                    : null}

                <TopBarMenuButton
                    className={cn(altTopBarBlock('Shortcut', { minified: isMinified }), altTopBarBlock('MenuBtn'))}
                    isWizard={isWizard}
                    btnProps={{
                        className: altTopBarBlock('IconButton'),
                        iconClassName: altTopBarBlock('MenuIcon'),
                    }}
                    // TODO: Perhaps worth adding for other buttons as well? Not too clean of a pattern though
                    onClose={this.simulateUnfocusedMousedOverTopBar}
                />
            </div>

            {!browser.isMinimized() ?
                <BannerNotification />
                : null}

            {isBrowserFuse5Enabled() ? <FileProcessingNotification /> : null}
        </div>;
    }
}

const WrappedTopBarAlt = inject('browser', 'research', 'history', 'env', 'research')(
    observer(NewTopBarAlternative)
);

const TopBarAlternative = (props) => {
    return isBrowserFuse5Enabled() ? <WrappedTopBarAlt {...props}/> : <OldTopBarAlternative {...props}/>;
};

export default TopBarAlternative;
